import { FC } from 'react';
import Skeleton from '../presentational/skeleton';

const SkeletonGuildRosterPage: FC<any> = () => {
  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ position: 'relative' }}>
        <div style={{ marginTop: 24 }}>
          <Skeleton height={190} />
        </div>

        <div style={{ marginTop: 24 }}>
          <Skeleton height={31} />
          <Skeleton variant="item" height={979} animate />
          <Skeleton height={41} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonGuildRosterPage;

